import React from 'react';
import { FileText, AlertTriangle, File as FileEdit, BookOpen, Download, GitCompare } from 'lucide-react';

const FEATURES = [
  {
    icon: FileText,
    title: 'Full Compliance Report',
    desc: 'Detailed clause-by-clause analysis against current UK housing law and the Renters Rights Bill.',
  },
  {
    icon: AlertTriangle,
    title: 'Legal Risk Assessment',
    desc: 'Every clause rated for compliance risk with clear explanations of potential legal exposure.',
  },
  {
    icon: FileEdit,
    title: 'Rewritten Draft',
    desc: 'A fully rewritten agreement aligned to the Renters Rights Bill, ready to use immediately.',
  },
  {
    icon: BookOpen,
    title: 'Plain English Explanations',
    desc: 'No legal jargon. Every finding explained clearly so you understand exactly what needs attention.',
  },
  {
    icon: Download,
    title: 'Downloadable PDF',
    desc: 'Your complete review report and rewritten agreement delivered as professional PDF documents.',
  },
  {
    icon: GitCompare,
    title: 'Original Comparison',
    desc: 'Side-by-side comparison showing exactly what changed between your original and the compliant version.',
  },
];

export function WhatYouGet() {
  return (
    <section className="py-20 sm:py-28 bg-gray-50 bg-diagonal-lines">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-16 animate-on-scroll">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">What You Get</h2>
          <p className="text-lg text-gray-500 max-w-xl mx-auto">
            Everything you need to ensure your tenancy agreement is fully compliant and legally sound.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {FEATURES.map((feature, i) => {
            const Icon = feature.icon;
            return (
              <div
                key={feature.title}
                className={`animate-on-scroll delay-${(i % 3) * 100 + 100} group bg-white rounded-2xl border border-gray-200 p-6 hover:shadow-elevated-lg hover:border-gray-300 transition-all duration-300`}
              >
                <div className="w-12 h-12 bg-gray-50 rounded-xl flex items-center justify-center mb-4 group-hover:bg-emerald-600 transition-colors duration-300">
                  <Icon className="w-5 h-5 text-gray-700 group-hover:text-white transition-colors duration-300" />
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">{feature.title}</h3>
                <p className="text-sm text-gray-500 leading-relaxed">{feature.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
